import * as React from 'react'
import MUIRadioGroup from '@mui/material/RadioGroup'

const RadioGroup = (props) => <MUIRadioGroup {...props} />

export default RadioGroup
